<template>
    <el-scrollbar class="reach-bottom-scroll" ref="reachBottomScroll">
        <slot></slot>
    </el-scrollbar>
</template>

<script>
export default {
    props: {
        reachBottomDistance: {
            type: Number,
            default: 50
        }
    },
    mounted(){
        this.$refs.reachBottomScroll.wrap.addEventListener('scroll', this.scrollHandle)
    },
    beforeDestroy(){
        this.$refs.reachBottomScroll.wrap.removeEventListener('scroll', this.scrollHandle)
    },
    methods: {
        scrollHandle(e){
            if(e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop <= this.reachBottomDistance){
                this.$emit('reach-bottom')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.reach-bottom-scroll{
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ReachBottomHandler/index.vue